/*
 * Wishlist repaint on back/forward navigation.
 *
 * The theme paints the wishlist state (header badge, .wishlist-added on the
 * heart buttons) once, during its own init (assets/theme.js,
 * setLocalStorageProductForWishlist). Mobile Safari restores a page from the
 * back-forward cache with its OLD DOM - no scripts re-run - so after adding a
 * product on the PDP and swiping back, the home page still showed the badge
 * and hearts from before the add until a manual refresh.
 *
 * This repaints both from localStorage whenever a cached page is restored
 * (pageshow with persisted) and whenever the tab becomes visible again (the
 * wishlist may have changed in another tab meanwhile). It writes exactly what
 * theme.js would have written - same key, same class, same label strings - so
 * the two can never disagree.
 */
(function () {
  function items() {
    try {
      return (JSON.parse(localStorage.getItem('wishlistItem')) || []).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function paint() {
    var list = items();

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
    });

    var strings = window.wishlist || {};
    document.querySelectorAll('[data-wishlist][data-wishlist-handle]').forEach(function (el) {
      var added = list.indexOf(el.getAttribute('data-wishlist-handle')) > -1;
      el.classList.toggle('wishlist-added', added);
      var label = el.querySelector('.text');
      if (label && strings.add && strings.added) {
        label.textContent = added ? strings.added : strings.add;
      }
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) paint();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paint();
  });
})();
